/* PlansFeatureComparisonTable.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["id"],
  _excluded2 = ["id"],
  _excluded3 = ["id"],
  _excluded4 = ["id"];
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _16 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import { Accordion, BodySmall, breakpointValues, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { MarketplaceStoreEditionType } from '@atlassian/mpac-types/graphql-gateway-types';
import { editionConstants } from '@atlassian/mpac-utils';
import { Table, TableCell, TableRow } from '../../TableComponent/TableComponent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _15 = "._1bah1b1v{justify-content:space-around}";
const _14 = "._16jlkb7n{flex-grow:1}";
const _13 = "._ca0qu2gc{padding-top:var(--ds-space-100,8px)}";
const _12 = "._k48p4jg8{font-weight:normal}";
const _11 = "._2rkopxbi{border-radius:var(--ds-space-200,1pc)}";
const _10 = "._1bah1h6o{justify-content:center}";
const _9 = "._16jl11wp{flex-grow:3}";
const _8 = "._1ul913ks{min-width:28rem}";
const _7 = "._i0dlf1ug{flex-basis:0%}";
const _6 = "._1o9zkb7n{flex-shrink:1}";
const _5 = "._16jlqfx8{flex-grow:5}";
const _4 = "._4cvr1h6o{align-items:center}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const {
  TEST_IDS
} = editionConstants;
const {
  ACCORDION_LIST_ITEM,
  FEATURE_COMPARISON_TABLE,
  FEATURE_COMPARISON_DESKTOP_VIEW,
  FEATURE_COMPARISON_MOBILE_VIEW
} = TEST_IDS;
const {
  Advanced,
  Standard
} = MarketplaceStoreEditionType;
const firstColumnStyle = null;
const genericColumnStyle = null;
const mobileFeatureSectionStyle = null;
const mobileFeatureTableStyle = null;
const featureDescription = null;
const mobileFeatureTableCellStyle = null;
const editionIndicatorStyle = null;
const getCheckedIcon = editionLabel => /*#__PURE__*/_jsx(CheckCircleIcon, {
  size: "medium",
  label: "".concat(editionLabel, "-edition-feature"),
  primaryColor: "var(--ds-icon-success, #22A06B)"
});
const getEditionIndicator = editionLabel => /*#__PURE__*/_jsxs(CC, {
  children: [/*#__PURE__*/_jsx(CS, {
    children: [_, _2, _3, _4]
  }), /*#__PURE__*/_jsxs("div", {
    className: ax(["_zulpu2gc _1e0c1txw _2lx21bp4 _4cvr1h6o"]),
    children: [editionLabel, getCheckedIcon(editionLabel)]
  })]
});
const TableHeaderRow = () => /*#__PURE__*/_jsxs(TableRow, {
  children: [/*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5, _6, _7, _8]
    }), /*#__PURE__*/_jsx(TableCell, {
      className: ax(["_16jlqfx8 _1o9zkb7n _i0dlf1ug _1ul913ks"]),
      children: "Features"
    })]
  }), /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _6, _7, _2, _4, _10]
    }), /*#__PURE__*/_jsx(TableCell, {
      className: ax(["_16jl11wp _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o"]),
      children: "Standard"
    })]
  }), /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _6, _7, _2, _4, _10]
    }), /*#__PURE__*/_jsx(TableCell, {
      className: ax(["_16jl11wp _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o"]),
      children: "Advanced"
    })]
  })]
});
const FeatureRow = _ref => {
  let {
    name,
    description,
    editionType
  } = _ref;
  return /*#__PURE__*/_jsxs(TableRow, {
    "data-testId": "".concat(editionType, "-feature-row-desktop"),
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_5, _6, _7, _8]
      }), /*#__PURE__*/_jsx(TableCell, {
        "aria-label": "".concat(name, ", included in ").concat(editionType === Standard ? 'standard and advanced' : 'advanced'),
        className: ax(["_16jlqfx8 _1o9zkb7n _i0dlf1ug _1ul913ks"]),
        children: /*#__PURE__*/_jsx(Accordion, {
          title: name,
          testId: ACCORDION_LIST_ITEM,
          lessSpacing: true,
          children: /*#__PURE__*/_jsx(BodySmall, {
            children: description
          })
        })
      })]
    }), editionType === Standard ? /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_9, _6, _7, _2, _4, _10]
      }), /*#__PURE__*/_jsx(TableCell, {
        className: ax(["_16jl11wp _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o"]),
        children: getCheckedIcon('Standard')
      })]
    }) : /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_9, _6, _7, _2, _4, _10]
      }), /*#__PURE__*/_jsx(TableCell, {
        className: ax(["_16jl11wp _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o"])
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_9, _6, _7, _2, _4, _10]
      }), /*#__PURE__*/_jsx(TableCell, {
        className: ax(["_16jl11wp _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o"]),
        children: getCheckedIcon('Advanced')
      })]
    })]
  });
};
const FeatureTableMobile = _ref2 => {
  let {
    name,
    description,
    editionType
  } = _ref2;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11]
    }), /*#__PURE__*/_jsxs(Table, {
      "data-testId": "".concat(editionType, "-feature-table-mobile"),
      className: ax(["_2rkopxbi"]),
      children: [/*#__PURE__*/_jsx(TableRow, {
        children: /*#__PURE__*/_jsx(TableCell, {
          children: /*#__PURE__*/_jsx(Accordion, {
            title: name,
            testId: ACCORDION_LIST_ITEM,
            lessSpacing: true,
            children: /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_12, _13]
              }), /*#__PURE__*/_jsx(BodySmall, {
                className: ax(["_k48p4jg8 _ca0qu2gc"]),
                children: description
              })]
            })
          })
        })
      }), /*#__PURE__*/_jsx(TableRow, {
        children: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_14, _6, _7, _2, _15]
          }), /*#__PURE__*/_jsxs(TableCell, {
            className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bah1b1v"]),
            children: [editionType === Standard && getEditionIndicator('Standard'), getEditionIndicator('Advanced')]
          })]
        })
      })]
    })]
  });
};
export const PlansFeatureComparisonTable = _ref3 => {
  let {
    editionFeatures
  } = _ref3;
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  const standardEdition = editionFeatures.find(edition => edition.type === Standard);
  const advancedEdition = editionFeatures.find(edition => edition.type === Advanced);
  const FeatureTableDesktop = () => /*#__PURE__*/_jsxs(Table, {
    "data-testId": FEATURE_COMPARISON_DESKTOP_VIEW,
    children: [/*#__PURE__*/_jsx(TableHeaderRow, {}), standardEdition === null || standardEdition === void 0 ? void 0 : standardEdition.features.map(_ref4 => {
      let {
          id
        } = _ref4,
        feature = _objectWithoutProperties(_ref4, _excluded);
      return /*#__PURE__*/_jsx(FeatureRow, _objectSpread(_objectSpread({}, feature), {}, {
        editionType: Standard
      }), id);
    }), advancedEdition === null || advancedEdition === void 0 ? void 0 : advancedEdition.features.map(_ref5 => {
      let {
          id
        } = _ref5,
        feature = _objectWithoutProperties(_ref5, _excluded2);
      return /*#__PURE__*/_jsx(FeatureRow, _objectSpread(_objectSpread({}, feature), {}, {
        editionType: Advanced
      }), id);
    })]
  });
  const FeatureTablesMobile = () => /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_16, _2, _3]
    }), /*#__PURE__*/_jsxs("section", {
      "data-testId": FEATURE_COMPARISON_MOBILE_VIEW,
      className: ax(["_zulpxy5q _1e0c1txw _2lx21bp4"]),
      children: [standardEdition === null || standardEdition === void 0 ? void 0 : standardEdition.features.map(_ref6 => {
        let {
            id
          } = _ref6,
          feature = _objectWithoutProperties(_ref6, _excluded3);
        return /*#__PURE__*/_jsx(FeatureTableMobile, _objectSpread(_objectSpread({}, feature), {}, {
          editionType: Standard
        }), id);
      }), advancedEdition === null || advancedEdition === void 0 ? void 0 : advancedEdition.features.map(_ref7 => {
        let {
            id
          } = _ref7,
          feature = _objectWithoutProperties(_ref7, _excluded4);
        return /*#__PURE__*/_jsx(FeatureTableMobile, _objectSpread(_objectSpread({}, feature), {}, {
          editionType: Advanced
        }), id);
      })]
    })]
  });
  return /*#__PURE__*/_jsx("div", {
    "data-testId": FEATURE_COMPARISON_TABLE,
    children: isMobile ? /*#__PURE__*/_jsx(FeatureTablesMobile, {}) : /*#__PURE__*/_jsx(FeatureTableDesktop, {})
  });
};